import * as types from 'models/actionTypes'
import { STATE_NOMINAL, STATE_FETCHING } from 'constants/stateTypes'

export const initialState = {
    isLoggedIn: false,
    wid: -1,
    metricsId: '',
    email: null,
    firstName: null,
    lastName: null,
    isAdmin: false,
    canBeAdmin: false,
    signupLoginStatus: null,
    isNewUser: false,
    redirectUrl: null,
    loginType: [],
    subCatalogs: null,
    canChangePassword: false,
    passwordResetStatus: STATE_NOMINAL,
    changePasswordStatus: STATE_NOMINAL,
    triggerPasswordResetStatus: STATE_NOMINAL,
    earlyAccessSubscribeStatus: STATE_NOMINAL,
    hasSeenMagicEraserTutorial: false,
    appDownloadSmsStatus: STATE_NOMINAL,
}

const user = (state = initialState, action) => {
    switch (action.type) {
        case types.RECEIVE_USER:
            return {
                ...state,
                isAdmin: action.userData.isStaff,
                canBeAdmin: action.userData.isStaff,
                isLoggedIn: action.userData.isLoggedIn,
                wid: action.userData.wid || initialState.wid,
                metricsId: action.userData.metricsId || initialState.metricsId,
                email: action.userData.email || initialState.email,
                firstName: action.userData.firstName || initialState.firstName,
                lastName: action.userData.lastName || initialState.lastName,
                isNewUser: action.userData.isFirstTime || initialState.isNewUser,
                loginType: action.userData.loginType || initialState.loginType,
                subCatalogs: action.userData.subCatalogs || initialState.subCatalogs,
                canChangePassword: action.userData.loginType.includes('Email'),
            }
        case types.SET_ADMIN:
            return {
                ...state,
                isAdmin: action.shouldBeAdmin,
            }
        case types.FAILED_RECEIVE_USER:
            return {
                ...state,
                isLoggedIn: false,
                error: action.error,
            }
        case types.RECEIVE_USER_LOGIN:
        case types.RECEIVE_USER_SIGNUP:
            return {
                ...state,
                signupLoginStatus: action.response.status,
            }
        case types.LOGIN_NEEDED:
            return {
                ...state,
                redirectUrl: action.redirectUrl,
            }
        case types.TRIGGER_PASSWORD_RESET:
            return {
                ...state,
                triggerPasswordResetStatus: STATE_FETCHING,
            }
        case types.RESET_PASSWORD:
            return {
                ...state,
                passwordResetStatus: STATE_FETCHING,
            }
        case types.RECEIVE_TRIGGER_PASSWORD_RESET:
            return {
                ...state,
                triggerPasswordResetStatus: action.status,
            }
        case types.RECEIVE_RESET_PASSWORD:
            return {
                ...state,
                passwordResetStatus: action.status,
            }
        case types.REQUEST_EARLY_ACCESS:
            return {
                ...state,
                earlyAccessSubscribeStatus: STATE_FETCHING,
            }
        case types.RECEIVE_EARLY_ACCESS:
            return {
                ...state,
                earlyAccessSubscribeStatus: action.status,
            }
        case types.REQUEST_CHANGE_PASSWORD:
            return {
                ...state,
                changePasswordStatus: STATE_FETCHING,
            }
        case types.RECEIVE_CHANGE_PASSWORD:
            return {
                ...state,
                changePasswordStatus: action.status,
            }
        case types.RESET_CHANGE_PASSWORD_STATUS:
            return {
                ...state,
                changePasswordStatus: STATE_NOMINAL,
            }
        case types.MAGIC_ERASER_TUTORIAL_SEEN:
            return {
                ...state,
                hasSeenMagicEraserTutorial: true,
            }
        case types.RECEIVE_APP_DOWNLOAD_SMS:
            return {
                ...state,
                appDownloadSmsStatus: action.status,
            }
        case types.REQUEST_APP_DOWNLOAD_SMS:
            return {
                ...state,
                appDownloadSmsStatus: STATE_FETCHING,
            }
        case types.RESET_APP_DOWNLOAD_SMS_STATUS:
            return {
                ...state,
                appDownloadSmsStatus: STATE_NOMINAL,
            }
        default:
            return state
    }
}

export default user
